var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOldCourses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.096,
    height: 40,
    viewBox: "0 0 53.096 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(-471 -444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(0 60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(476.35 398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(27.912)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 13.76,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 13.76,
    transform: "translate(0 2.949)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 13.76,
    transform: "translate(0 5.897)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 13.76,
    transform: "translate(0 8.846)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 13.76,
    transform: "translate(0 11.794)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 13.76,
    transform: "translate(0 14.743)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(471 384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box-fragile-svgrepo-com",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M50.491,51.307H2.6A2.536,2.536,0,0,0,0,53.761V88.853a2.536,2.536,0,0,0,2.6,2.454H50.491a2.536,2.536,0,0,0,2.6-2.454V53.761A2.536,2.536,0,0,0,50.491,51.307Zm.942,37.546a.917.917,0,0,1-.942.888H2.6a.917.917,0,0,1-.942-.888V53.761a.917.917,0,0,1,.942-.888H50.491a.917.917,0,0,1,.942.888V88.853Z",
    transform: "translate(0 -51.307)"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "_7098014_congratulations_book_school_graduation_education_icon",
    "data-name": "7098014_congratulations_book_school_graduation_education_icon",
    d: "M59.509,30.356a26.036,26.036,0,0,0-3.868-.38v-2.4a.277.277,0,0,0-.042-.141.2.2,0,0,0-.02-.03.28.28,0,0,0-.1-.089.025.025,0,0,0-.006-.005L48.56,24.257a.291.291,0,0,0-.233,0L41.417,27.31a.288.288,0,0,0,0,.528l2.67,1.18v1.042a21.9,21.9,0,0,0-5.926.3.288.288,0,0,0-.24.285V45.258a.288.288,0,0,0,.338.283c8.475-1.433,9.381,1.639,9.389,1.669a.288.288,0,0,0,.281.223h1.813a.289.289,0,0,0,.281-.223c.007-.031.832-3.116,9.389-1.671a.284.284,0,0,0,.235-.066.289.289,0,0,0,.1-.22V30.641A.289.289,0,0,0,59.509,30.356Zm-3.661.682v1.151h-.987V31.038a.492.492,0,0,1,.469-.489h.054A.491.491,0,0,1,55.848,31.038ZM52.8,29.014l2.262-1v1.958a14.8,14.8,0,0,0-2.262.189Zm-4.359-4.179,5.543,2.448H48.444a.288.288,0,1,0,0,.577h5.542l-5.542,2.449-6.2-2.735Zm-.117,6.056a.289.289,0,0,0,.233,0l3.666-1.619v4.983a9.352,9.352,0,0,1-3.782.64,9.335,9.335,0,0,1-3.78-.64V29.272Zm-9.829,0a20.633,20.633,0,0,1,5.589-.24v3.783a.291.291,0,0,0,.141.25,8.851,8.851,0,0,0,4.219.787h.1v8.607c-.776-.721-2.525-1.765-6.15-1.765a25.248,25.248,0,0,0-3.9.335ZM59.172,44.922c-7.569-1.2-9.281,1.174-9.63,1.941H48.128c-.347-.766-2.059-3.14-9.63-1.941V43.231c8.327-1.34,10.064,1.739,10.079,1.77.005.01.016.015.022.024a.246.246,0,0,0,.041.045.269.269,0,0,0,.1.066c.011,0,.016.015.028.018a.258.258,0,0,0,.062.007h.007a.269.269,0,0,0,.066-.008c.014,0,.02-.016.033-.02a.28.28,0,0,0,.092-.058.292.292,0,0,0,.043-.046c.006-.01.017-.014.022-.024.016-.031,1.749-3.108,10.079-1.77Zm0-2.274c-6.36-1-9.036.487-10.048,1.431V35.445a8.3,8.3,0,0,0,3.541-.768.29.29,0,0,0,.141-.25V30.759a12.953,12.953,0,0,1,1.587-.182,1.054,1.054,0,0,0-.109.462v1.442a.288.288,0,0,0,.288.288h1.562a.289.289,0,0,0,.288-.288V31.039a1.059,1.059,0,0,0-.109-.459,26.263,26.263,0,0,1,2.853.309Z",
    transform: "translate(440.284 427.767)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldCourses);
export default __webpack_public_path__ + "static/media/old-courses.cb73ccb5f6a925b70a85f602972d750f.svg";
export { ForwardRef as ReactComponent };